var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"c-link g-display-ib g-cursor-p",class:_vm.className,style:(_vm.style),attrs:{"href":"javascript:;"},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"g-verticala-m"},[_vm._t("default")],2),_c('a-icon',{staticClass:"g-fonts-12 g-marginl-4",attrs:{"type":"right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }